import GroupsIcon from '@mui/icons-material/Groups';
import { Grid } from '@mui/material';
import * as React from 'react';
import { Views } from 'react-big-calendar';
import * as Redux from 'react-redux';
import * as ROUTES from '../../router/Routes';
import { LoadingWidget } from '../../widgets';
import CalendarioEventosComponent from '../eventos/components/CalendarioEventos';
import { getDashboardAction } from './DashboardAction';
import CardNumberComponent from './components/CardNumber';

const DashboardAdminBandaView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const dashboardStore = Redux.useSelector((state) => state.dashboard);

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await getDashboardAction(dispatch, 'dashboard', entidadesStore.activo.id);
      setLoading(false);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={loading && !dashboardStore.dashboard}
          text="Cargando estadísticas..."
        />
      </Grid>
      <Grid item md={12}>
        <Grid container>
          <CardNumberComponent
            icon={<GroupsIcon fontSize="large" />}
            text="Usuarios"
            number={dashboardStore.dashboard?.usuarios ?? 0}
            to={ROUTES.usuEntidades.to}
            md={4}
          />
        </Grid>
      </Grid>
      <Grid item md={12}>
        <CalendarioEventosComponent isDetalles viewCalendar={Views.WEEK} />
      </Grid>
      {/* {!entidadesStore.settings.isBanda && (
        <CardNumberComponent
          icon={<GroupsIcon fontSize="large" />}
          text="Docentes"
          number={dashboardStore.dashboard?.docentes ?? 0}
          to={ROUTES.docentes.to}
        />
      )}
      {!entidadesStore.settings.isBanda && (
        <CardNumberComponent
          icon={<GroupsIcon fontSize="large" />}
          text="Estudiantes"
          number={dashboardStore.dashboard?.estudiantes?.total ?? 0}
          to={ROUTES.estudiantes.to}
        />
      )}
      <Grid item md={6}>
        {!entidadesStore.settings.isBanda && (
          <GeneroEstudinatesPieChartPanelControl
            mas={
              dashboardStore.dashboard?.estudiantes?.generos?.masculinos ?? 0
            }
            fem={dashboardStore.dashboard?.estudiantes?.generos?.femeninas ?? 0}
          />
        )}
      </Grid> */}
      {/* <Grid item md={6}>
          <MomentosPieChartPanelControl />
        </Grid> */}
      {/* <Grid item md={12}>
        <MesesBarChartPanelControl />
      </Grid> */}
    </Grid>
  );
};

export default DashboardAdminBandaView;
